import { render, staticRenderFns } from "./RelationshipInfo.vue?vue&type=template&id=4a0c7288&scoped=true"
import script from "./RelationshipInfo.vue?vue&type=script&lang=js"
export * from "./RelationshipInfo.vue?vue&type=script&lang=js"
import style0 from "./RelationshipInfo.vue?vue&type=style&index=0&id=4a0c7288&prod&lang=css"
import style1 from "./RelationshipInfo.vue?vue&type=style&index=1&id=4a0c7288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c7288",
  null
  
)

export default component.exports